import React, { } from 'react'
import {
  CardText, CardBody,
  CardTitle, Container, Row, Col
} from 'reactstrap'
import BasicForm from './BasicForm'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import actionCreators from '../redux/actions'
import numeral from 'numeral'
import apiService from '../utils/apiService'
import { getSelectedStateInfo } from '../redux/reducers'
const graphic = '/assets/slide8-graphic.svg'

function Slide8 ({ onNextRequested, onPrevRequested, onIncrementProgress, onDecrementProgress, set, formProps, apiService }) {
  const onPrevClick = () => {
    onDecrementProgress()
    onPrevRequested()
  }

  const onNextClick = async () => {
    // this method returns true or false based on the successful API call made to SFB,
    // currently we are not doing anything if it fails but logging the error caught, but code below can implement whatever we'd like
    await apiService.attemptPostData(formProps.appState).catch(e => {
      console.error(`Error occurred sending API data accross to SFB, ${e}`)
    })
    // TODO: handle unsuccessful API in the way SFB wants it handled (if they do)
    // if (!dataSentSuccesful) {
    // implement logic here
    // }
    onIncrementProgress()
    onNextRequested()
  }

  const onWorkingWithAgentNameInput = (e) => {
    set('workingWithAgentName', e.target.value)
  }

  const onMessageInput = (e) => {
    set('emailMessage', e.target.value)
  }

  const onPhoneInput = (e) => {
    set('phoneNo', e.target.value)
  }

  const onFirstNameInput = (e) => {
    set('firstName', e.target.value)
  }

  const onLastNameInput = (e) => {
    set('lastName', e.target.value)
  }

  const onEmailInput = (e) => {
    set('emailAddress', e.target.value)
  }

  const onAddressInput = (e) => {
    set('address', e.target.value)
  }

  const onCityInput = (e) => {
    set('city', e.target.value)
  }

  const onZipCodeInput = (e) => {
    set('zipCode', e.target.value)
  }

  return (
    <CardBody className='app-slide Slide8 w-100'>
      <Container fluid>
        <Row>

          <Col xs={12} xl={6} className='d-flex flex-wrap mt-3'>
            <img src={graphic} width={195} height={195} alt='Your Estimate!' />
            <div className='box-estimate mt-4 mt-xl-0'><CardTitle className='pb-xl-2'><h2>Your Estimate!</h2></CardTitle>
              <CardText className='mb-0'>This estimate is based on the information you provided and here’s why you need it:</CardText>
              <ul>
                <li>Pay for final expenses</li>
                <li>Pay off your debt</li>
                <li>Pay for children’s education</li>
                <li className='mb-4'>Income replacement to retain your standard of living</li>
              </ul>
              <h4 className='pt-3'>{numeral(formProps.estimate).format('$0,000')}</h4 >

            </div>

          </Col>
          <Col xs={12} xl={6}>
            <BasicForm
              onCityInput={onCityInput}
              onAddressInput={onAddressInput}
              onZipCodeInput={onZipCodeInput}
              onEmailInput={onEmailInput}
              onFirstNameInput={onFirstNameInput}
              onLastNameInput={onLastNameInput}
              onMessageInput={onMessageInput}
              onPhoneInput={onPhoneInput}
              onWorkingWithAgentNameInput={onWorkingWithAgentNameInput}
              formProps={formProps}
              onPrevClick={onPrevClick}
              onNextClick={onNextClick} />
          </Col>

        </Row>
      </Container>
    </CardBody>
  )
}

const mapStateToProps = (state, props) => ({
  formProps: {
    emailAddress: state.app.emailAddress,
    emailMessage: state.app.emailMessage,
    phoneNo: state.app.phoneNo,
    firstName: state.app.firstName,
    lastName: state.app.lastName,
    sendEmailCopyToUser: state.app.sendEmailCopyToUser,
    workingWithAgentName: state.app.workingWithAgentName,
    estimate: state.app.estimate,
    state: getSelectedStateInfo(state.app.state).state,
    city: state.app.city,
    zip: state.app.zip,
    appState: state
  },
  apiService: apiService
})

const mapDispatchToProps = dispatch =>
  bindActionCreators(actionCreators, dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(Slide8)
